// Retour à la page demandée après connexion (audit 2026-10-01, B07).
// Un lien d'e-mail vers /data?symbol=SNTS ouvert sans session doit y revenir une fois connecté.

const PARAMETRE = 'next';

// Après une déconnexion volontaire, l'utilisateur retourne à la page publique, pas à un écran de
// connexion qui le ramènerait sur la page qu'il vient de quitter.
let deconnexionVolontaire = false;

export const marquerDeconnexionVolontaire = (): void => {
  deconnexionVolontaire = true;
};

/** Adresse de connexion qui mémorise la page demandée. La racine renvoie vers la page d'accueil publique. */
export const cheminConnexion = (pathname: string, search = ''): string => {
  if (deconnexionVolontaire) {
    deconnexionVolontaire = false;
    return '/home';
  }
  if (pathname === '/' || pathname === '') return '/home';
  return `/login?${PARAMETRE}=${encodeURIComponent(pathname + search)}`;
};

/**
 * Destination après connexion. N'accepte qu'un chemin interne : « //hote » ou « https://… »
 * permettraient de rediriger l'utilisateur hors du site depuis un lien forgé.
 */
export const destinationApresConnexion = (search: string, defaut = '/dashboard'): string => {
  const cible = new URLSearchParams(search).get(PARAMETRE);
  if (!cible || !cible.startsWith('/') || cible.startsWith('//') || cible.includes('\\')) return defaut;
  if (cible.startsWith('/login') || cible.startsWith('/home')) return defaut;
  return cible;
};
